import { BaseListView } from "@/base/BaseListView";
import { definePendingListView } from "@/base/list/defineListView";

// Policies (BRK-S251): a BaseListView page PMS can't serve yet. PMS keeps no
// policy records for brokers to read; bound coverage shows on its submission
// meanwhile. BRK-S215 wires this list to `GET /api/broker/policies` once
// PMS-S560 ships it; the columns follow its list item.
const POLICIES_LIST = definePendingListView({
  plannedEndpoint: "/api/broker/policies",
  noun: "policies",
  title: "Policies",
  context: "Active and expired policies across your book.",
  columns: ["Policy", "Carrier", "Coverage", "Effective", "Expires", "Status"],
  notYetAvailable: {
    title: "Policies will be listed here",
    body: "Until then, bound coverage shows on its submission.",
    href: "/submissions",
    linkLabel: "Go to Submissions",
  },
});

export function PoliciesPage() {
  return <BaseListView def={POLICIES_LIST} />;
}
